import { defineMessages } from '@jutro/locale';

export default defineMessages({
    quotes: {
        id: 'ml.gateway.accountQuotes.Quotes',
        defaultMessage: 'Quotes'
    },
    none: {
        id: 'ml.gateway.accountQuotes.None',
        defaultMessage: 'None'
    },
    oneQuote: {
        id: 'ml.gateway.accountQuotes.1 quote',
        defaultMessage: '1 quote'
    },
    xQuotes: {
        id: 'ml.gateway.accountQuotes.X quotes',
        defaultMessage: '{number} quotes'
    },
    auto: {
        id: 'ml.gateway.accountQuotes.AUTO',
        defaultMessage: 'AUTO'
    },
    home: {
        id: 'ml.gateway.accountQuotes.HOME',
        defaultMessage: 'HOME'
    },
    umbrella: {
        id: 'ml.gateway.accountQuotes.UMBRELLA',
        defaultMessage: 'UMBRELLA'
    },
    quoteDate: {
        id: 'ml.gateway.accountQuotes.Quote Date',
        defaultMessage: 'Quote Date'
    },
    quoteNumber: {
        id: 'ml.gateway.accountQuotes.Quote #',
        defaultMessage: 'Quote #'
    },
    bundle: {
        id: 'ml.gateway.accountQuotes.Bundle',
        defaultMessage: 'Bundle'
    },
    policyType: {
        id: 'ml.gateway.accountQuotes.Policy Type',
        defaultMessage: 'Policy Type'
    },
    bookRoll: {
        id: 'ml.gateway.accountQuotes.Book Roll',
        defaultMessage: 'Book Roll'
    },
    initiator: {
        id: 'ml.gateway.accountQuotes.Initiator',
        defaultMessage: 'Initiator'
    },
    premium: {
        id: 'ml.gateway.accountQuotes.Premium',
        defaultMessage: 'Premium'
    },
    description: {
        id: 'ml.gateway.accountQuotes.Description',
        defaultMessage: 'Description'
    },
    choiceAgent: {
        id: 'ml.gateway.accountQuotes.Choice Agent',
        defaultMessage: 'Choice Agent'
    },
    expand: {
        id: 'ml.gateway.accountQuotes.Expand',
        defaultMessage: 'Expand' 
    },
    collapse: {
        id: 'ml.gateway.accountQuotes.Collapse',
        defaultMessage: 'Collapse'
    },
    resumeQuotePopupTitle: {
        id: 'ml.gateway.accountQuotes.resumeQuotePopupTitle',
        defaultMessage: 'Quote is not complete'
    },
    resumeQuotePopupMsgBookroll: {
        id: 'ml.gateway.accountQuotes.resumeQuotePopupMsgBookroll',
        defaultMessage: 'Quote has not been completed. Please contact your Book Consolidation manager.'
    },
    resumeQuotePopupMsgPcsIa: {
        id: 'ml.gateway.accountQuotes.resumeQuotePopupMsgPcsIa',
        defaultMessage: 'Quote has not been completed. Contact us at 1-800-255-0332 for assistance.'
    },
    resumeQuotePopupMsgDefault: {
        id: 'ml.gateway.accountQuotes.resumeQuotePopupMsgDefault',
        defaultMessage: 'Quote has not been completed. The quote must be completed in PolicyCenter.'
    },
    close: {
        id: 'ml.gateway.accountQuotes.CLOSE',
        defaultMessage: 'CLOSE'
    }
});